import {useProductDisplayImages} from '../../../hooks/use-product-display-images'
import {MAIN_IMAGES_IMAGE_TYPE} from '../../../constants'
import {useMemo} from 'react'

const useCockpitGalleryImages = (product, derivedProduct) => {
    const {videos, variationParams} = derivedProduct
    const images = useProductDisplayImages(product, MAIN_IMAGES_IMAGE_TYPE, variationParams)
    const mainGalleryImages = useMemo(() => {
        const result = [...images]
        videos
            // sort videos by position to prevent later video shifting previously added ones
            ?.sort(
                (a, b) =>
                    // edge case for position 1 or non-positive number,
                    // it should be added at the end of list so we sort it last
                    (a.position > 1 ? a.position : Number.MAX_SAFE_INTEGER) -
                    (b.position > 1 ? b.position : Number.MAX_SAFE_INTEGER)
            )
            .forEach((video) => {
                const position = video.position || 0
                // the logic is slightly different from splice, as we use 0, empty, undefined and 1 (default) to insert at the end
                result.splice(
                    position > 1
                        ? // positive number means to insert before the item with that index counting from 1, so we need to subtract 1
                          position - 1
                        : // any other value means to add to the end
                          result.length,
                    0,
                    video
                )
            })
        return result
    }, [images, videos])

    return mainGalleryImages
}

export default useCockpitGalleryImages
